import { addRatEventWithData } from './rat';
import * as webStorage from '@com.rakuten.esd/myr-web-storage';
import store from './store';

export const RAT_CP_EVENT = {
    email_verification: {
        resend_otp: 'resend_otp',
        update_email: 'update_email',
        verify_email: 'verify_email',
        verify_existing_email_success: 'verify_existing_email_success',
        verify_new_email_success: 'verify_new_email_success',
        invalid_password: 'invalid_password',
        verify_otp_fail: 'verify_otp_fail',
    },
    password_update: {
        password_edit: 'password_edit',
        password_invalid: 'password_invalid',
        password_weak: 'password_weak',
        password_leaked: 'password_leaked',
        password_edit_success: 'password_edit_success',
        password_weak_ui: 'password_weak_ui',
        password_invalid_ui: 'password_invalid_ui',
        password_mismatch: 'password_mismatch',
        password_invalid_mismatch: 'password_invalid_mismatch',
        password_invalid_weak: 'password_invalid_weak',
        password_weak_mismatch: 'password_weak_mismatch',
        password_invalid_mismatch_weak: 'password_invalid_mismatch_weak',
    },
    session_deactivation: {
        revoke_user_sessions: 'revoke_user_sessions',
        revoke_user_sessions_success: 'revoke_user_sessions_success',
    },
    security_section: {
        details_email_2fa: 'details_email_2fa',
        enable_email_2fa: 'enable_email_2fa',
        passkey_manage: 'passkey_manage',
        setup_security_question: 'setup_security_question',
    },
    member_cancellation: {
        cancel_member: 'cancel_member',
        keep_member: 'keep_member',
        start_cancel_member: 'start_cancel_member',
        cancel_member_success: 'cancel_member_success',
        cancel_member_fail: 'cancel_member_fail',
        quit_cancel_member: 'quit_cancel_member',
    },
    mydata: {
        mydata_link: 'mydata_link',
    },
    about: {
        login: 'login',
        registration: 'registration',
        myid: 'myid',
        header_logo: 'header_logo',
        go_to_link: 'go_to_link',
        bu_icon: 'bu_icon',
    },
    payment_method: {
        edit_card: 'edit_card',
        edit_card_success_be: 'edit_card_success_be',
        edit_card_failed_be: 'edit_card_failed_be',
        edit_card_name_invalid_chars_kanji: 'edit_card_name_invalid_chars_(kanji_diacritics)',
        edit_card_name_pan_error: 'edit_card_name_pan_error',
        edit_card_name_blank: 'edit_card_name_blank',
        edit_card_name_invalid_chars: 'edit_card_name_invalid_chars',
        edit_card_expiry_date_error: 'edit_card_expiry_date_error',
        set_default_card_in_list_view: 'set_default_card_in_list_view',
        set_default_card_success_be: 'set_default_card_success_be',
        set_default_card_failed_be: 'set_default_card_failed_be',
        delete_card: 'delete_card',
        delete_card_confirm: 'delete_card_confirm',
        delete_card_success_be: 'delete_card_success_be',
        delete_card_failed_be: 'delete_card_failed_be',
        add_card: 'add_card',
        add_card_success_be: 'add_card_success_be',
        add_card_failed_be: 'add_card_failed_be',
        add_card_name_invalid_chars_kanji: 'add_card_name_invalid_chars_(kanji_diacritics)',
        add_card_name_pan_error: 'add_card_name_pan_error',
        add_card_name_blank: 'add_card_name_blank',
        add_card_name_invalid_chars: 'add_card_name_invalid_chars',
        add_card_already_exist: 'add_card_already_exist',
        add_card_expiry_date_error: 'add_card_expiry_date_error',
        add_card_number_invalid: 'add_card_number_invalid',
    },
    social_account_linkage: {
        unlink: 'unlink',
        unlink_confirm: 'unlink_confirm',
        unlink_cancel: 'unlink_cancel',
        unlink_successful: 'unlink_successful',
        unlink_failed: 'unlink_failed',
    },
} as const;

export type RatCpEventCategory = keyof typeof RAT_CP_EVENT;

export type RatCpEventName<Category extends RatCpEventCategory> =
    keyof typeof RAT_CP_EVENT[Category];

export function addRatEvent<C extends RatCpEventCategory>(
    category: C,
    eventNameKey: RatCpEventName<C>,
    extraData: object = {},
) {
    const isRatProd = store?.getState().app.appConfig.RAT_PROD;
    try {
        if (!(category in RAT_CP_EVENT) || !(eventNameKey in RAT_CP_EVENT[category])) {
            if (!isRatProd) {
                console.error(
                    `Invalid RAT event: Category "${category}" or event name key "${String(
                        eventNameKey,
                    )}" is not defined in RAT_CP_EVENT.`,
                );
            }
            return;
        }
        const ratData = getRatDataFromStorage();
        if (!ratData || !ratData.clientId) {
            console.error('Client ID is missing in RAT data.');
            return;
        }
        const client_id = ratData.clientId;
        const event_name_value = RAT_CP_EVENT[category][eventNameKey];
        const event_name_formatted = String(event_name_value).replace(/_/g, ' ');
        const event_category_formatted = String(category).replace(/_/g, ' ');
        addRatEventWithData({
            eventType: 'click',
            cpData: {
                client_id,
                event_category: event_category_formatted,
                event_name: event_name_formatted,
                ...extraData,
            },
        });
    } catch (error) {
        if (!isRatProd) {
            console.error('Error adding RAT event:', error);
        }
    }
}

function getRatDataFromStorage() {
    const clientId = webStorage.getActiveClientId();
    return {
        clientId: clientId || 'UNDEFINED',
    };
}
